// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__31J68","footer":"ReportModalFilter_footer__1V0KU"};